var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { DropWrapper, DropSection, DropLRContent } from "./components";
import lighten from "polished/lib/color/lighten";
import styled from "styled-components";
import { Input, Button, Radio, ButtonGroup, Checkbox, DateRangePicker, Tooltip, TooltipText, } from "../../..";
const StyledTooltip = styled(props => React.createElement(Tooltip, Object.assign({}, props))) `
	${TooltipText} {
		background-color: #fff;
		color: #383838;
		border: 1px solid ${(props) => lighten(0.2, props.theme.colors.primary)};
		text-align: left;
		padding: 11px 10px;
		border-radius: 8px;
		margin-top: 10px;
		::after {
			top: 50%;
			left: 100%;
			margin-top: -5px;
			border-color: transparent transparent transparent #fff;
		}
	}
`;
let ProtableFilters = class ProtableFilters extends React.Component {
    constructor() {
        super(...arguments);
        this.componentDidMount = () => {
            this.initialAction();
        };
        this.initialAction = () => {
            if (this.props.filterConfigs && this.props.filterConfigs.dateRange)
                this.updateDateRange(this.daysAgoMills(0), Date.now());
            for (const filter of this.props.query.filters) {
                if (filter.defaultValues) {
                    for (const defaultValue of filter.defaultValues) {
                        this.props.store.filterToggle(filter.key, defaultValue);
                    }
                }
            }
        };
        this.daysAgoMills = (days) => {
            return Date.now() - 1000 * 60 * 60 * 24 * days;
        };
        this.setRange = (start) => {
            this.updateDateRange(start, Date.now());
        };
        this.updateDateRange = (start, end) => this.props.store.update({
            fromDate: start,
            toDate: end,
        });
        this.handleReset = () => {
            this.props.store.reset();
            this.initialAction();
            this.props.store.fetch();
        };
    }
    render() {
        const { query, store, region, filterConfigs } = this.props;
        const s = store.s;
        const showSearch = !filterConfigs || (filterConfigs && !filterConfigs.noSearch);
        const showSort = !filterConfigs || (filterConfigs && !filterConfigs.noSort);
        return (React.createElement(DropWrapper, { active: s.dropdown === "filters" },
            filterConfigs &&
                filterConfigs.dateRange &&
                s.fromDate &&
                s.toDate && (React.createElement(DropSection, null,
                React.createElement(DropLRContent, null,
                    React.createElement("p", { className: "font-semi-bold" }, "Date Range"),
                    React.createElement("div", null,
                        React.createElement(DateRangePicker, { formats: region.formats, timezone: region.timezone, start: s.fromDate, end: s.toDate, onSelect: (type, timestamp) => {
                                if (type === "start")
                                    this.props.store.update({
                                        fromDate: timestamp,
                                    });
                                else if (type === "end")
                                    this.props.store.update({
                                        toDate: timestamp,
                                    });
                            } }),
                        React.createElement("div", { className: "m-t-3" },
                            React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(0)), className: "m-r-2" }, "Today"),
                            React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(7)), className: "m-r-2" }, "Last 7 Days"),
                            React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(30)), className: "m-r-2" }, "Last 30 Days"),
                            React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(90)), className: "m-r-2" }, "Last 90 Days"),
                            React.createElement(Button, { color: "primary-inverse", size: "xxs", onClick: () => this.setRange(this.daysAgoMills(1000)) }, "All Time")))))),
            showSearch && (React.createElement(DropSection, null,
                React.createElement(DropLRContent, null,
                    React.createElement("p", { className: "font-semi-bold" }, "Search"),
                    React.createElement(Input, { value: s.search, onChange: (e) => store.update({ search: e.target.value }), placeholder: "Search by name, email, phone..." })))),
            showSort && (React.createElement(React.Fragment, null,
                React.createElement(DropSection, null,
                    React.createElement(DropLRContent, null,
                        React.createElement("p", { className: "font-semi-bold" }, "Sort By"),
                        React.createElement("div", { className: "flex-line flex-wrap child-mr-15" }, query.sortKeys.map((sort, i) => {
                            const name = `${sort.value}-sort-key`;
                            return (React.createElement("div", { key: i, className: "p-tb-1" },
                                React.createElement(Radio, { id: name, name: name, checked: s.sortKey === sort.value, title: sort.label, value: sort.value, onChange: () => {
                                        store.update({
                                            sortKey: sort.value,
                                        });
                                    } })));
                        })))),
                React.createElement(DropSection, null,
                    React.createElement(DropLRContent, null,
                        React.createElement("p", { className: "font-semi-bold" }, "Sort Direction"),
                        React.createElement("div", null,
                            React.createElement(ButtonGroup, { width: 100, size: "xs", selected: s.sortDirection, options: [
                                    { value: -1, name: "Descending" },
                                    { value: 1, name: "Ascending" },
                                ], onSelect: (v) => store.update({
                                    sortDirection: v.value,
                                }) })))))),
            query.filters.map((filter, indexFilter) => (React.createElement(DropSection, { key: indexFilter },
                React.createElement(DropLRContent, null,
                    React.createElement("div", { className: "font-semi-bold" }, filter.label),
                    React.createElement("div", { className: "flex-line flex-wrap child-mr-15" }, filter.values.map((value, indexValue) => {
                        const name = `${value.value}-filter-key-${indexValue}`;
                        return (React.createElement("div", { key: indexValue, className: "p-tb-1" },
                            React.createElement(StyledTooltip, { text: value.tooltip, width: 200, position: "bottom", disable: !value.tooltip },
                                React.createElement(Checkbox, { id: name, name: name, checked: store.filterIsActive(filter.key, value.value), label: value.label, onChange: () => store.filterToggle(filter.key, value.value) }))));
                    })))))),
            React.createElement(DropSection, null,
                React.createElement(Button, { color: "primary", size: "xs", onClick: store.fetch, className: "m-r-2" }, "Search"),
                React.createElement(Button, { color: "primary-inverse", size: "xs", onClick: this.handleReset }, "Reset"))));
    }
};
ProtableFilters = __decorate([
    observer
], ProtableFilters);
export { ProtableFilters };
//# sourceMappingURL=filters.js.map